module.exports = __webpack_public_path__ + "img/imag10.eaecfc10.png";